import React from 'react';
import Box from '@mui/material/Box';
import { PDFDoc } from 'organisms';
import useStyles from './styles';
import { PageHeader } from 'molecules';

/**
 * Legal Component
 *
 * Displays a legal document page with title and embedded PDF document.
 * Used for Terms of Service and Privacy Policy pages.
 *
 * Features:
 * - Page title with divider
 * - Embedded PDF document viewer
 * - Responsive layout with centered content
 *
 * Default export is wrapped with `withLayout` using `sm` width (640px max, `SITE_LAYOUT.layoutContentSm`).
 *
 * Used in:
 * - Terms of Service page
 * - Privacy Policy page
 *
 * @param props - Component props
 * @param props.pageTitle - Title text displayed at top of page
 * @param props.pdfURL - URL to the PDF document to display
 * @returns Legal component with title and PDF document
 */
const Legal = (props: LegalProps) => {
  const { classes } = useStyles();

  const { pageTitle, pdfURL } = props;

  return (
    <Box className={classes.container} data-layout="legal">
      <PageHeader title={pageTitle} divider />
      <Box className={classes.contentContainer}>
        <PDFDoc url={pdfURL} />
      </Box>
    </Box>
  );
};

export interface LegalProps {
  /** Title text displayed at top of page */
  pageTitle: string;
  /** URL to the PDF document to display */
  pdfURL: string;
}

export default Legal;
